import { render, staticRenderFns } from "./industryRight.vue?vue&type=template&id=68fc1533&scoped=true"
import script from "./industryRight.vue?vue&type=script&lang=js"
export * from "./industryRight.vue?vue&type=script&lang=js"
import style0 from "./industryRight.vue?vue&type=style&index=0&id=68fc1533&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc1533",
  null
  
)

export default component.exports